import Mediator from "../services/Mediator.js";

const handlers = {
  onSelectAll() {
    Mediator.selectAllObjects();
  },
  onPaste() {
    Mediator.pasteCopiedObject();
  },
  onCopy() {
    Mediator.copyActiveObject();
  },
  onDelete() {
    Mediator.removeActive();
  },
  onDeleteOthers() {
    Mediator.removeAllExceptActive();
  },
  onClone() {
    Mediator.cloneActiveObject();
  },
  onFlipHorizontally() {
    Mediator.flipHorizontally();
  },
  onFlipVertically() {
    Mediator.flipVertically();
  },
  onStraighten() {
    Mediator.straightenActive();
  },
  onSendToBack() {
    Mediator.sendActiveToBack();
  },
  onSendToBackwards() {
    Mediator.sendActiveToBackwards();
  },
  onBringToFront() {
    Mediator.bringActiveToFront();
  },
  onBringToForward() {
    Mediator.bringActiveToForward();
  },
  onCenterVertically() {
    return () => {
      Mediator.centerActiveVertically();
    };
  },
  onCenterHorizontally() {
    return () => {
      Mediator.centerActiveHorizontally();
    };
  },
  onResizeActiveObjectToFill() {
    return () => {
      Mediator.resizeActiveObjectToFill();
    };
  },
  onRestoreRatio() {
    Mediator.restoreRatioOfActiveObject();
  }
};

export const layerMenu = [
  {
    name: `Отразить по вертикали`,
    icon: `fas fa-chevron-up`,
    handleClick: handlers.onFlipVertically
  },
  {
    name: `Отразить по горизонтали`,
    icon: `fas fa-chevron-right`,
    handleClick: handlers.onFlipHorizontally
  },
  {
    name: `Выровнять угол`,
    icon: `fas fa-sync-alt`,
    handleClick: handlers.onStraighten
  },
  {
    name: `На один слой вниз`,
    icon: `fas fa-step-backward`,
    handleClick: handlers.onSendToBack,
    hotKey: `Ctrl+[`
  },
  {
    name: `На нижний слой`,
    icon: `fas fa-fast-backward`,
    handleClick: handlers.onSendToBackwards,
    hotKey: `Ctrl+Alt+[`
  },
  {
    name: `На один слой вверх`,
    icon: `fas fa-step-forward`,
    handleClick: handlers.onBringToFront,
    hotKey: `Ctrl+]`
  },
  {
    name: `На верхний слой`,
    icon: `fas fa-fast-forward`,
    handleClick: handlers.onBringToForward,
    hotKey: `Ctrl+Alt+]`
  },
  {
    name: `Центрировать по вертикали`,
    icon: `fas fa-arrows-alt-v`,
    handleClick: handlers.onCenterVertically()
  },
  {
    name: `Центрировать по горизонтали`,
    icon: `fas fa-arrows-alt-h`,
    handleClick: handlers.onCenterHorizontally()
  },
  {
    name: `Заполнить всю печатную область`,
    icon: `fas fa-expand`,
    handleClick: handlers.onResizeActiveObjectToFill()
  },
  {
    name: `Восстановить пропорции`,
    icon: `fas fa-percentage`,
    handleClick: handlers.onRestoreRatio
  }
];

export const objectMenu = [
  {
    name: `Выделить все`,
    hotKey: `Ctrl+A`,
    handleClick: handlers.onSelectAll
  },
  {
    name: `Копировать`,
    icon: `far fa-copy`,
    hotKey: `Ctrl+C`,
    handleClick: handlers.onCopy
  },
  {
    name: `Вставить`,
    icon: `far fa-clipboard`,
    hotKey: `Ctrl+V`,
    handleClick: handlers.onPaste
  },
  {
    name: `Удалить`,
    icon: `far fa-trash-alt`,
    hotKey: `Delete, Backspace`,
    handleClick: handlers.onDelete
  },
  {
    name: `Отразить по вертикали`,
    icon: `fas fa-chevron-up`,
    handleClick: handlers.onFlipVertically
  },
  {
    name: `Отразить по горизонтали`,
    icon: `fas fa-chevron-right`,
    handleClick: handlers.onFlipHorizontally
  },
  {
    name: `Выровнять угол`,
    icon: `fas fa-sync-alt`,
    handleClick: handlers.onStraighten
  },
  {
    name: `На один слой вниз`,
    icon: `fas fa-step-backward`,
    handleClick: handlers.onSendToBack,
    hotKey: `Ctrl+[`
  },
  {
    name: `На нижний слой`,
    icon: `fas fa-fast-backward`,
    handleClick: handlers.onSendToBackwards,
    hotKey: `Ctrl+Alt+[`
  },
  {
    name: `На один слой вверх`,
    icon: `fas fa-step-forward`,
    handleClick: handlers.onBringToFront,
    hotKey: `Ctrl+]`
  },
  {
    name: `На верхний слой`,
    icon: `fas fa-fast-forward`,
    handleClick: handlers.onBringToForward,
    hotKey: `Ctrl+Alt+]`
  },
  {
    name: `Центрировать по вертикали`,
    icon: `fas fa-arrows-alt-v`,
    handleClick: handlers.onCenterVertically()
  },
  {
    name: `Центрировать по горизонтали`,
    icon: `fas fa-arrows-alt-h`,
    handleClick: handlers.onCenterHorizontally()
  },
  {
    name: `Заполнить всю печатную область`,
    icon: `fas fa-expand`,
    handleClick: handlers.onResizeActiveObjectToFill()
  }
];

export const systemMenu = [
  {
    name: `Копировать`,
    icon: `copy`,
    hotKey: `Ctrl+C`,
    handleClick: handlers.onCopy
  },
  {
    name: `Вставить`,
    icon: `clipboard`,
    hotKey: `Ctrl+V`,
    handleClick: handlers.onPaste
  },
  {
    name: `Удалить`,
    icon: `trash`,
    hotKey: `Delete, Backspace`,
    handleClick: handlers.onDelete
  }
];

export const menu = [
  {
    name: `Выделить все`,
    hotKey: `Ctrl+A`,
    handleClick: handlers.onSelectAll
  },
  {
    name: `Вставить`,
    icon: `far fa-clipboard`,
    hotKey: `Ctrl+V`,
    handleClick: handlers.onPaste
  }
];
